import React from 'react';
import InputSelect from '../InputSelect';
import FetchInputSelectOptions from '../../FetchInputSelectOptions';
import { fetchCourseOffers } from 'services/options_services';

const CourseOfferInput = ({params, ...props}) => (
  <FetchInputSelectOptions params={params} fetchOptions={fetchCourseOffers}>
    {({ options, isLoading }) => (
      <InputSelect
        name="course_offer"
        label="Oferta de Curso"
        placeholder="Selecionar"
        options={options}
        isLoading={isLoading}
        getOptionValue={(d) => d.id}
        required={props.required}
        getOptionLabel={(d) =>
          `${d.course} - ${d.offer_type} / Etapas: ${d.num_terms}`
        }
        {...props}
      />
    )}
  </FetchInputSelectOptions>
);
export default CourseOfferInput;
